
export default {
  name: 'ListActions',
  props: {
    confirm: {
      type: Boolean,
      default: () => false
    },
    confirmTitle: {
      type: String,
      default: 'Selesai'
    },
    pending: {
      type: Boolean,
      default: () => false
    },
    pendingTitle: {
      type: String,
      default: 'Tidak Sesuai'
    },
    refund: {
      type: Boolean,
      default: () => false
    },
    refundTitle: {
      type: String,
      default: 'Refund'
    }
  }
}
